import { MantineProvider } from '@mantine/core';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';
import AppRoutes from './routes';
import { theme } from './theme';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@src/styles/global.css';

function App() {
  if (process.env.NODE_ENV !== 'production') {
    // Adds messages only in a dev environment

    console.log('Loading Apollo client error messages');
    loadDevMessages();
    loadErrorMessages();
  }

  return (
    <MantineProvider theme={theme}>
      {/* // theme={{ colorScheme: 'dark' }} */}
      <AppRoutes />
    </MantineProvider>
  );
}

export default App;
